import React from "react";
import AdminBrandEdit from "../../../components/admin/brands/brand-edit";
import AdminTemplate from "../../../templates/admin-template";

const AdminBrandEditPage = () => {
  return <AdminTemplate> <AdminBrandEdit/> </AdminTemplate>;
};

export default AdminBrandEditPage;
